
import React from 'react';
import HeaderWithBackButton from '@/components/common/HeaderWithBackButton';

interface AnalyticsHeaderProps {
  selectedRange: number;
  setSelectedRange: (range: number) => void;
  DATE_RANGES: Array<{ name: string; value: number }>;
}

const AnalyticsHeader = ({ selectedRange, setSelectedRange, DATE_RANGES }: AnalyticsHeaderProps) => {
  return (
    <>
      <HeaderWithBackButton />
      
      <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold">Usage Analytics</h1>
          <p className="text-muted-foreground mt-1">
            Monitor usage patterns and user engagement
          </p>
        </div>
        
        <div className="flex gap-2">
          {DATE_RANGES.map(range => (
            <button 
              key={range.value}
              className={`px-4 py-2 text-sm font-medium rounded-md ${
                selectedRange === range.value 
                  ? 'bg-primary text-primary-foreground' 
                  : 'bg-secondary text-secondary-foreground'
              }`}
              onClick={() => setSelectedRange(range.value)}
            >
              {range.name}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default AnalyticsHeader;
